import { Component, Input, OnInit } from '@angular/core';
import { Vehicle } from '../../../shared/domain/vehicle';

@Component({
    selector   : 'nw-vehicle-info-item-v1',
    templateUrl: './vehicle-info-item-v1.component.html'
})
export class VehicleInfoItemV1Component implements OnInit {
    @Input() vehicle: Vehicle;
    @Input() rllbTag: boolean;

    channel;

    ngOnInit() {
        this.channel = this.rllbTag ? 'rllb' : 'db';
    }


}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/vehicle-info-item-v1/vehicle-info-item-v1.component.ts